<!-- <div class="overlay" *ngIf="scope.wait">
  <i class="fas fa-spinner fa-spin"></i>
</div> -->
<video class="capture" autoplay muted #videoPlayer>
  <source src="{{ filePath }}" />
</video>

